import DefaultModal from '../defaultModal/DefaultModal';
import useTranslation from '../../../../hooks/translation/useTranslation';
import { ReactComponent as RefundSuccess } from '../../../../../resources/images/svg/refundSuccessful.svg';
import { useModal } from '../../../../contexts/modalsContext/modalsContext';

function RefundConfirmationModal() {
  const { trans } = useTranslation();

  const {
    ticketRefundConfirmModal,
    setTicketRefundConfirmModal,
  } = useModal();

  return (
    <DefaultModal
      show={ticketRefundConfirmModal?.show}
      setShow={() => {
        setTicketRefundConfirmModal({ show: false, data: null });
      }}
      className="confirmation-modal"
    >
      <div className="flex flex-col gap-[58px] items-center">
        <div className="flex flex-col gap-9 items-center">
          <RefundSuccess />
          <p className="m-0 text-base text-center">
            {trans('refund_successful').replace('{ticketID}', ticketRefundConfirmModal?.data?.ticketId || '')}
          </p>
        </div>
      </div>
    </DefaultModal>
  );
}

export default RefundConfirmationModal;
